import { z } from 'zod';
/** Zod + TS contract for payment-file row UI metadata (matches CSV-derived fields from processors). */
export const PaymentRowDisplayMetadataSchema = z.object({
    supplier_reference: z.string().optional(),
    payee_display: z.string().optional(),
    amount: z.string().optional(),
});
//# sourceMappingURL=payment-row-display-metadata.js.map